// extracted by mini-css-extract-plugin
export default {"loading":"Loader_loading__Rb1OM","spin":"Loader_spin__E4RJ0"};